import { getWeightRangeByLabel, WeightRange, WeightRangeLabel } from '@brenger/utils';
import cn from 'classnames';
import React from 'react';
import { InputMeta } from '.';
import { InputWrapper } from './InputWrapper';
import { IconCarretUpDown } from '../basics/icons';

type ModifiedSelect = Omit<React.InputHTMLAttributes<HTMLSelectElement>, 'onChange' | 'value'>;

interface WeightSelectProps extends ModifiedSelect {
  id?: string;
  name?: string;
  value: WeightRange | null;
  onChange: (value: WeightRange) => void;
  options: WeightRange[];
  className?: string;
  disabled?: boolean;
  meta?: InputMeta;
}

export const WeightRangeSelect: React.FC<WeightSelectProps> = ({
  id,
  name,
  value,
  onChange,
  options,
  className,
  disabled,
  meta,
  style,
}) => {
  return (
    <InputWrapper {...meta} fullWidth={false}>
      <label style={{ width: '130px' }} className={cn('relative', className)}>
        <select
          id={id || 'weight-select'}
          name={name || 'weight-select'}
          value={value?.label}
          disabled={disabled}
          onChange={e => {
            const range = getWeightRangeByLabel(e.target.value as WeightRangeLabel);
            if (range) onChange(range);
          }}
          style={{
            textAlign: 'right',
            paddingRight: '20px',
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            appearance: 'none',
            backgroundImage: 'none',
            border: 'none',
            ...style,
          }}
          className={cn('input-default', className)}
        >
          {options.map(opt => (
            <option key={opt.label} value={opt.label} disabled={opt.disabled}>
              {opt.label}
            </option>
          ))}
        </select>
        <IconCarretUpDown
          style={{
            pointerEvents: 'none',
            position: 'absolute',
            right: '-0.1rem',
            top: '50%',
            transform: 'translateY(-50%)',
            marginTop: '0.1rem',
            color: disabled ? '#6b7280' : '#0073fa',
          }}
        />
      </label>
    </InputWrapper>
  );
};
